import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.sass']
})
export class VideoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
